import { Component, Input, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import { NavController } from '@ionic/angular';
import { filter } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { MobileService } from 'src/app/services/mobile.service';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  logo = environment.logo;

  title: any;
  isMobile: any;
  isHome: any = false;
  isLanding: any = false;
  isPublic: any = false;
  allCommunes: any;
  selectedCommune: any;
  insee: any;
  elu: any;
  epciInfos: any = {
    infos: undefined,
    cities: [],
  };
  selectedCommuneEpci: any;

  // take as input preview

  @Input() preview: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private mobileService: MobileService,
    private apiService: ApiService,
    private authService: AuthService,
    private navCtrl: NavController,
    private location: Location
  ) {
    this.isMobile = mobileService.isMobile;
    this.mobileService.isMobileChanges.subscribe((isMobile: any) => {
      this.isMobile = isMobile;
    });
  }

  departementInfos: any;

  async ngOnInit() {
    this.setTitleFromRoute(this.activatedRoute);
    this.elu = JSON.parse(localStorage.getItem('elu') as string);

    if (this.elu && this.elu.epci_id) {
      let tempEpciInfos = this.apiService.epciInfos;
      if (tempEpciInfos) {
        this.formatEpciInfos(tempEpciInfos);
      }
      this.apiService.epciInfosChanges.subscribe((epciInfos: any) => {
        this.formatEpciInfos(epciInfos);
      });
    }

    this.departementInfos = this.apiService.departementInfos;
    this.apiService.departementInfosChanges.subscribe((infos: any) => {
      this.departementInfos = infos;
    });

    if (this.preview) {
      this.selectedCommune = this.preview;
      return;
    }

    if (this.router.url === '/home') {
      this.isHome = true;
    }

    if (this.router.url === '/public/landing') {
      this.isLanding = true;
    }

    if (this.router.url.startsWith('/public')) {
      this.isPublic = true;
    }

    if (this.router.url.startsWith('/commune')) {
      this.insee = this.activatedRoute.snapshot.paramMap.get('insee');
      this.selectedCommune = await this.apiService.returnCurrentCommune(
        this.insee
      );
    }

    return;
  }

  setTitleFromRoute(route: ActivatedRoute) {
    while (route.firstChild) {
      route = route.firstChild;
    }

    route.data.subscribe((data) => {
      if (data['title']) {
        this.title = data['title'];
      }
    });
  }

  setTitleFromInsee(insee: any) {
    if (!this.allCommunes) return;
    this.selectedCommune = this.allCommunes.find((commune: any) => {
      return commune.insee === insee;
    });
  }

  goBack() {
    if (this.router.url.startsWith('/actualite-preview') || this.isPublic) {
      // window.history.back();
      this.location.back();
    } else if (this.router.url.startsWith('/carte')) {
      this.location.back();
    } else {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }
  }

  goBackToEpci() {
    this.router.navigate(['/epci/' + this.elu.epci_id]);
  }

  goBackToDepartement() {
    if (this.elu.departement_id) {
      this.router.navigate(['/departement/' + this.elu.departement_id]);
    } else {
      this.router.navigate(['/home']);
    }
  }

  goBackToConseil() {
    this.router.navigate(['/conseil']);
  }

  logout() {
    this.authService.logout();
  }

  formatEpciInfos(epciInfos: any) {
    this.epciInfos.infos = epciInfos.epci_infos;
    this.epciInfos.cities = epciInfos.epci_cities;
  }

  changeEpciCommune(event: any) {
    this.router.navigate(['/commune/' + this.selectedCommuneEpci.insee]);
  }

  goBackToRegion() {
    this.router.navigate(['/home']);
  }
}
